/*var splide = new Splide( '.top-bar.splide', {
  type: 'loop',
  autoplay: true,
  autoWidth:true,
  interval: 4000,
  pauseOnHover: true,
  focus: 'center',
  speed: 1500,
  perPage: 1,
  direction: 'ltr',
  focus: 'center',
  gap: '0px',
  pagination: false,
  easing: 'cubic-bezier(0.7, 0.01, 0.27, 0.99)',
  drag: false,
} );
splide.mount();*/

var width_screen = window.innerWidth;
// Padding body
if (!!document.querySelector(".shopify-section.liste-des-marques") === true){
  var listeMarques = document.querySelector(".shopify-section.liste-des-marques").offsetHeight;
}else{
  var listeMarques = 0;
}
if (!!document.querySelector("#shopify-section-announcement-bar") === true && !!document.querySelector("#shopify-section-header") === true ){
  var announcement_height = document.querySelector("#shopify-section-announcement-bar").offsetHeight;
  var header = document.querySelector("#shopify-section-header").offsetHeight;
  document.querySelector("body").style.cssText = "padding-top: " + (announcement_height + header + listeMarques) + "px;";
} else if (!!document.querySelector("#shopify-section-announcement-bar") === true){
  var announcement_height = document.querySelector("#shopify-section-announcement-bar").offsetHeight;
  document.querySelector("body").style.cssText = "padding-top: " + (announcement_height + listeMarques) + "px;";
} else if (!!document.querySelector("#shopify-section-header") === true){
  var header = document.querySelector("#shopify-section-header").offsetHeight;
  document.querySelector("body").style.cssText = "padding-top: " + (header + listeMarques) + "px;";
}

// Recherche
document.querySelector("header .menu-icones .loupe").onclick = function() {
  if ( document.querySelector(".block_search").classList.contains("open") === true ){
    document.querySelector("header .menu-principal>ul").removeAttribute("style");
    document.querySelector(".block_search").classList.remove("open");
    document.querySelector("#shadow-search").remove();
  }else{
    document.querySelector("header .menu-principal>ul").style.cssText = "opacity: 0;";
    document.querySelector(".block_search").classList.add("open");
    document.querySelector("#MainContent").insertAdjacentHTML("afterbegin", '<div id="shadow-search" style="z-index:2;background-color:#3b3e3b;height:100vh;width:100vw;display: block;opacity: .2;position: fixed;top: 0;left: 0;"></div>');
    document.querySelector(".block_search input").focus();
    document.querySelector("#shadow-search").onclick = function() {
      document.querySelector("header .menu-principal>ul").removeAttribute("style");
      document.querySelector(".block_search").classList.remove("open");
      document.querySelector("#shadow-search").remove();
    };
  }
};
document.querySelector(".block_search .loupe-search").onclick = function() {
  var texte_recherche = document.querySelector(".block_search input").value.replaceAll(' ', '+');
  window.location.replace("https://www.tempus-shop.fr/search?q=" + texte_recherche + "&options%5Bprefix%5D=last");
}

// Grille recherche
if (!!document.querySelector(".template-search__results li") === true){
  var liste_li = document.querySelectorAll('.template-search__results li');
  for (var i = 0; i < liste_li.length; i++) {
  	var verif_empty = liste_li[i].innerHTML;
    if (verif_empty){}else{
      liste_li[i].remove();
    }
  }
}

// Bouton enter Recherche
document.querySelector(".block_search input").addEventListener("keypress", function(event) {
  if (event.key === "Enter") {
    event.preventDefault();
    document.querySelector(".block_search .loupe-search").click();
  }
});


// Méga menu
/*document.querySelector(".mega-menu .liste-marques li:first-child").classList.add("active");
document.querySelector(".mega-menu .apercu-montres ul:first-child").classList.add("active");
var categories_marques = document.querySelectorAll('.mega-menu .liste-marques li');
for (var i = 0; i < categories_marques.length; i++) {
  categories_marques[i].addEventListener('click', function(event) {
      var class_categories_marques = this.getAttribute("class").replace(' active', '');
      console.log(class_categories_marques);
      document.querySelector(".mega-menu .liste-marques li.active").classList.remove("active");
      document.querySelector(".mega-menu .apercu-montres ul.active").classList.remove("active");
      document.querySelector('.mega-menu .liste-marques li.' + class_categories_marques).classList.add("active");
      document.querySelector('.mega-menu .apercu-montres ul.' + class_categories_marques).classList.add("active");
  });
}*/


document.addEventListener('DOMContentLoaded', function() {
  var collectionLinks = document.querySelectorAll('.mega-menu .apercu-collections .listc li a');
    var allProductContainers = document.querySelectorAll('.mega-menu .collection-products'); // Select all product containers
var linksinblod =document.querySelectorAll('.mega-menu .apercu-collections .listc li');
  var collectionDisplay = document.querySelector('.collection-display');
 var container = document.querySelector('.apercu-product-by-collection');
  collectionLinks.forEach(function(link) {
    link.addEventListener('click', function(event) {
      event.preventDefault();

      
      collectionLinks.forEach(function(otherLink) {
        otherLink.parentNode.classList.remove('active');
      });
      
      this.parentNode.classList.add('active');
      this.parentNode.style.listStyleType = 'none'; // Remove bullet point
      //collectionDisplay.style.display = 'none';
      var collectionUrl = this.dataset.collectionUrl;
       console.log("collectionUrl",collectionUrl);
      var urlParts = collectionUrl.split('/');
             console.log("urlParts",urlParts);

      var handle = urlParts[urlParts.length - 1]; // Extracts the last part of the URL



     // Hide all product containers before showing the new one
      allProductContainers.forEach(function(container) {
        container.style.display = 'none';
      });

      var matchingContainer = document.querySelector('.mega-menu .collection-products.' + handle);
    console.log("matching ",matchingContainer)
      if (matchingContainer) {

        matchingContainer.style.display = 'flex';
        container.style.display = 'block ';
        console.log("Showing products for: ", handle);
                 
        console.log("Product details: ", matchingContainer.innerHTML);

      } else {
        console.log("No matching products found for: ", handle);
      }
    });
  });
});

;








// // Méga menu nouveauté
// document.querySelector(".mega-menu .listm li:first-child").classList.add("active");
// document.querySelector(".mega-menu .apercu-nouv ul:first-child").classList.add("active");
// var categories_marques = document.querySelectorAll('.mega-menu .listm li');
// for (var i = 0; i < categories_marques.length; i++) {
//   categories_marques[i].addEventListener('click', function(event) {
//       var class_categories_marques = this.getAttribute("class").replace(' active', '');
//       document.querySelector(".mega-menu .listm li.active").classList.remove("active");
//       document.querySelector(".mega-menu .apercu-nouv ul.active").classList.remove("active");
//       document.querySelector('.mega-menu .listm li.' + class_categories_marques).classList.add("active");
//       document.querySelector('.mega-menu .apercu-nouv ul.' + class_categories_marques).classList.add("active");
//   });
// }
// Méga menu promotion
//document.querySelector(".mega-menu .listp li:first-child").classList.add("active");
//document.querySelector(".mega-menu .apercu-promotion ul:first-child").classList.add("active");
//var categories_marques = document.querySelectorAll('.mega-menu .listp li');
//for (var i = 0; i < categories_marques.length; i++) {
//  categories_marques[i].addEventListener('click', function(event) {
//      var class_categories_marques = this.getAttribute("class").replace(' active', '');
//      document.querySelector(".mega-menu .listp li.active").classList.remove("active");
//      document.querySelector(".mega-menu .apercu-promotion ul.active").classList.remove("active");
//      document.querySelector('.mega-menu .listp li.' + class_categories_marques).classList.add("active");
//      document.querySelector('.mega-menu .apercu-promotion ul.' + class_categories_marques).classList.add("active");
//  });
//}

// // Méga menu Tendances
// document.querySelector(".mega-menu .listt li:first-child").classList.add("active");
// document.querySelector(".mega-menu .apercu-tendances ul:first-child").classList.add("active");
// var categories_marques = document.querySelectorAll('.mega-menu .listt li');
// for (var i = 0; i < categories_marques.length; i++) {
//   categories_marques[i].addEventListener('click', function(event) {
//       var class_categories_marques = this.getAttribute("class").replace(' active', '');
//       document.querySelector(".mega-menu .listt li.active").classList.remove("active");
//       document.querySelector(".mega-menu .apercu-tendances ul.active").classList.remove("active");
//       document.querySelector('.mega-menu .listt li.' + class_categories_marques).classList.add("active");
//       document.querySelector('.mega-menu .apercu-tendances ul.' + class_categories_marques).classList.add("active");
//   });
// }




// Menu mobile
var li_children = document.querySelectorAll('.menu-mobile-principal .children-here>a');
for (var i = 0; i < li_children.length; i++) {
  li_children[i].addEventListener('click', function(event) {
      if ( this.parentElement.classList.contains("active") === true ){
        this.parentElement.classList.remove("active");
      }else{
        this.parentElement.classList.add("active");
      }
  });
}

var retourMenu = document.querySelectorAll('.retour-menu');
for (var i = 0; i < retourMenu.length; i++) {
  retourMenu[i].addEventListener('click', function(event) {
    this.parentElement.parentElement.classList.remove("active");
  });
}


// Ouvrir menu mobile
document.querySelector(".menu-burger").onclick = function() {
  var ul_children = document.querySelectorAll('.menu-mobile-principal .children-here');
  if ( document.querySelector(".menu-mobile").classList.contains("open") === true ){
    document.querySelector(".menu-mobile").classList.remove("open");
  }else{
    document.querySelector(".menu-mobile").classList.add("open");

    let menu2 = document.querySelectorAll('.menu-mobile .menu-mobile-principal>li>a');
    for (let j=0; j < menu2.length; j++) {
        setTimeout(function() {
            menu2[j].style.transform = 'translateY(0px)'; 
        }, ( 100 + (j * 100)));
    }
  }
};

// Click sur fermer
document.querySelector(".fermer-menu-mobile").onclick = function() {
  let menu = document.querySelectorAll('.menu-mobile .menu-mobile-principal>li>a');
  for (let j=0; j < menu.length; j++) {
      setTimeout(function() {
          menu[j].removeAttribute("style");
      }, ( 100 + (j * 100)));
  }
  var ul_children = document.querySelectorAll('.menu-mobile-principal .children-here.active');
  for (var i = 0; i < ul_children.length; i++) {
    var target = ul_children[i];
    target.querySelector(".menu-child").style.cssText = "right: 100%;";
    setTimeout(function () {
      target.classList.remove("active");
      target.querySelector(".menu-child").style.cssText = "transition: none; right: -100%;";
      target.removeAttribute("style");
    }, 600);
  }
  document.querySelector(".menu-mobile").classList.remove("open");
}


const listItems = document.querySelectorAll('.menu-mobile .menu-mobile-principal ul.menu-child li');
listItems.forEach((li, index) => {
  if (listItems[index + 1] && listItems[index + 1].querySelector('a[href="/collections/all"]')) {
    li.style.border = 'none';
  }
});

if (!!document.querySelector(".menu-description-detaillee") === true){
  var position_sticky_atc = document.querySelector(".menu-description-detaillee").offsetTop;
}

window.addEventListener('scroll',(event) => {
    var top = window.scrollY;
    if (top > 0){
        document.querySelector("#shopify-section-header").style.cssText = "box-shadow:0px 10px 30px rgba(0, 0, 0, 0.05);";
    }else{
        document.querySelector("#shopify-section-header").style.cssText = "box-shadow:0px 10px 30px rgba(0, 0, 0, 0);";
    }

    if (!!document.querySelector(".menu-description-detaillee") === true){
      var top_sticky_atc = document.querySelector(".product").offsetTop + document.querySelector(".product").offsetHeight;
      if ( top_sticky_atc <= top + 29 && document.querySelector(".menu-description-detaillee").getAttribute('style') != "position: fixed;top: 29px;" ){
          document.querySelector(".menu-description-detaillee").style.cssText = "position: fixed;top: 29px;";
          if (width_screen > 767) {document.querySelector(".product").style.cssText = "margin-bottom:75px;";}else{
            document.querySelector(".menu-description-detaillee").classList.add("top");
          }
      }else if( top + 29 <=  position_sticky_atc){
          document.querySelector(".menu-description-detaillee").style.cssText = "position: relative;top: unset;";
          document.querySelector(".product").style.cssText = "margin-bottom:0px;";
          if (width_screen < 767) {
            document.querySelector(".menu-description-detaillee").classList.remove("top");
          }
      }

      
      if (!!document.querySelector("#pourquoi-cette-montre") === true){
        var bottom_desc = document.querySelector("#pourquoi-cette-montre").offsetTop + document.querySelector("#pourquoi-cette-montre").offsetHeight;
        var top_desc = document.querySelector("#pourquoi-cette-montre").offsetTop;
        if ( top_desc <= Math.ceil(top) && bottom_desc - 104 > Math.ceil(top) ){
          document.querySelector(".menu-description-detaillee .pourquoi-cette-montre").classList.add("active");
        }else{
          document.querySelector(".menu-description-detaillee .pourquoi-cette-montre").classList.remove("active");
        }
      }

      if (!!document.querySelector("#description-technique") === true){
        var bottom_desc = document.querySelector("#description-technique").offsetTop + document.querySelector("#description-technique").offsetHeight;
        var top_desc = document.querySelector("#description-technique").offsetTop;
        if ( top_desc <= Math.ceil(top) && bottom_desc - 104 > Math.ceil(top) ){
          document.querySelector(".menu-description-detaillee .description-technique").classList.add("active");
        }else{
          document.querySelector(".menu-description-detaillee .description-technique").classList.remove("active");
        }
      }

      if (!!document.querySelector("#histoire-de-la-montre") === true){
        var bottom_desc = document.querySelector("#histoire-de-la-montre").offsetTop + document.querySelector("#histoire-de-la-montre").offsetHeight;
        var top_desc = document.querySelector("#histoire-de-la-montre").offsetTop;
        if ( top_desc <= Math.ceil(top) && bottom_desc - 104 > Math.ceil(top) ){
          document.querySelector(".menu-description-detaillee .histoire-de-la-montre").classList.add("active");
        }else{
          document.querySelector(".menu-description-detaillee .histoire-de-la-montre").classList.remove("active");
        }
      }
     
    }
});


// Filtres
if (!!document.querySelector("#FacetFiltersForm") === true){
  
  var width_screen = window.innerWidth;
  document.querySelector(".menu-filters .filtrer-par").onclick = function() {
      if (width_screen < 767) {
        document.querySelector(".mobile-facets__open-wrapper .mobile-facets__open").click();
      }else{
        if ( document.querySelector("#FacetFiltersForm").classList.contains("active") === true ){
          document.querySelector("#FacetFiltersForm").classList.remove("active");
          document.querySelector(".menu-filters .filtrer-par").classList.remove("ouvert");
        }else{
          document.querySelector("#FacetFiltersForm").classList.add("active");
          document.querySelector(".menu-filters .filtrer-par").classList.add("ouvert");
        }
      }
  };

  var nb_facet_remove = document.querySelectorAll("#FacetFiltersForm>.active-facets facet-remove").length;
  if ( nb_facet_remove > 1 ){
    document.querySelector("#FacetFiltersForm").classList.add("active");
    document.querySelector(".menu-filters .filtrer-par").classList.add("ouvert");
  }
}

if (!!document.querySelector(".menu-filters .trier-par") === true){
  var queryString = window.location.search;
  var urlParams = new URLSearchParams(queryString);
  var sort_by = urlParams.get('sort_by');
  document.head.insertAdjacentHTML('beforeend', '<style>#shopify-section-header a[href*="'+ sort_by +'"]:not(.facets__reset){font-family: Neue Haas Grotesk Display Medium;}#shopify-section-header a[href*="'+ sort_by +'"]:not(.facets__reset):before{transform: translateY(-1px);content:url(https://cdn.shopify.com/s/files/1/0589/8793/7963/files/menu-active.svg)!important;}</style>')
  document.querySelector(".menu-filters .trier-par span").onclick = function() {
    if ( document.querySelector(".menu-filters .trier-par").classList.contains("ouvert") === true ){
        document.querySelector(".menu-filters .trier-par").classList.remove("ouvert");
      }else{
        document.querySelector(".menu-filters .trier-par").classList.add("ouvert");
        document.querySelector(".menu-filters .trier-par").classList.add("ouvert");
      }
  };
}

// Columns collections
var width_screen = window.innerWidth;
if (width_screen < 767) {}else{
  var element_columns = document.querySelectorAll('.selection-alignement>div');
  for (var i = 0; i < element_columns.length; i++) {
  	element_columns[i].addEventListener('click', function(event) {
      if ( event.target.classList.contains("active") === false ){
        document.querySelector('.selection-alignement>div.active').classList.remove("active");
        event.target.classList.add("active");
        var class_column = document.querySelector('.selection-alignement>div.active').getAttribute("class").replace(' active','');
        if ( class_column == "colum3" ){
          document.head.insertAdjacentHTML('beforeend', '<style>.silder-product.collection .splide .splide__list .splide__slide:not(:nth-child(5n)){margin-right: unset;}.silder-product.collection .splide .splide__list .splide__slide:not(:nth-child(4n)){margin-right: unset;}.silder-product.collection .splide .splide__list .splide__slide:not(:nth-child(2n)){margin-right: unset;}.silder-product.collection .splide .splide__list .splide__slide:not(:nth-child(3n)){margin-right: 30px;}.silder-product .splide__slide{width: calc(33.33% - 20px);}.silder-product .splide__slide img{height: unset;margin-bottom: 10px;}.silder-product.collection .splide .splide__list .splide__slide{display: block;flex-direction: column;flex-wrap: wrap;height: unset;} .silder-product h3,.silder-product .price,.silder-product .all-labels{width: 100%;margin-left: 0;}</style>');
        }else if ( class_column == "colum4" ){
          document.head.insertAdjacentHTML('beforeend', '<style>.silder-product.collection .splide .splide__list .splide__slide:not(:nth-child(5n)){margin-right: unset;}.silder-product.collection .splide .splide__list .splide__slide:not(:nth-child(3n)){margin-right: unset;}.silder-product.collection .splide .splide__list .splide__slide:not(:nth-child(2n)){margin-right: unset;}.silder-product.collection .splide .splide__list .splide__slide:not(:nth-child(4n)){margin-right: 30px;}.silder-product .splide__slide{width: calc(25% - 22.5px);}.silder-product .splide__slide img{height: unset;margin-bottom: 10px;}.silder-product.collection .splide .splide__list .splide__slide{display: block;flex-direction: column;flex-wrap: wrap;height: unset;} .silder-product h3,.silder-product .price,.silder-product .all-labels{width: 100%;margin-left: 0;}</style>');
        }else if ( class_column == "colum5" ){
          document.head.insertAdjacentHTML('beforeend', '<style>.silder-product.collection .splide .splide__list .splide__slide:not(:nth-child(4n)){margin-right: unset;}.silder-product.collection .splide .splide__list .splide__slide:not(:nth-child(3n)){margin-right: unset;}.silder-product.collection .splide .splide__list .splide__slide:not(:nth-child(2n)){margin-right: unset;}.silder-product.collection .splide .splide__list .splide__slide:not(:nth-child(5n)){margin-right: 30px;}.silder-product .splide__slide{width: calc(20% - 24px);}.silder-product .splide__slide img{height: unset;margin-bottom: 10px;}.silder-product.collection .splide .splide__list .splide__slide{display: block;flex-direction: column;flex-wrap: wrap;height: unset;} .silder-product h3,.silder-product .price,.silder-product .all-labels{width: 100%;margin-left: 0;}</style>');
        }else if ( class_column == "colum2" ){
          document.head.insertAdjacentHTML('beforeend', '<style>.silder-product.collection .splide .splide__list .splide__slide:not(:nth-child(4n)){margin-right: unset;}.silder-product.collection .splide .splide__list .splide__slide:not(:nth-child(3n)){margin-right: unset;}.silder-product.collection .splide .splide__list .splide__slide:not(:nth-child(5n)){margin-right: unset;}.silder-product.collection .splide .splide__list .splide__slide:not(:nth-child(2n)){margin-right: 30px;}.silder-product .splide__slide{width: calc(50% - 15px);}.silder-product .splide__slide img{height: 130px;margin-bottom: 0;}.silder-product.collection .splide .splide__list .splide__slide{display: flex;flex-direction: column;flex-wrap: wrap;height: 160px;} .silder-product h3,.silder-product .price,.silder-product .all-labels{width: calc(100% - 180px);margin-left: 20px;}</style>');
        }
      }
  	});
  }
}

// Newsletter
var queryString = window.location.search;
var urlParams = new URLSearchParams(queryString);
var customer_posted = urlParams.get('customer_posted');
if ( customer_posted == "true" ){
  document.querySelector('.newsletter form').style.cssText = "display:none;";
  document.querySelector('.newsletter h2').style.cssText = "margin:0;";
  document.querySelector('.footet-newsletter form').style.cssText = "display:none;";
  document.querySelector('.newsletter h2').innerHTML = "Merci pour votre inscription à notre newsletter ! Vous allez recevoir un e-mail prochainement.";
  document.querySelector('.footet-newsletter p').innerHTML = "Merci pour votre inscription à notre newsletter ! Vous allez recevoir un e-mail prochainement.";
}

// Filters details mobile
var element = document.querySelectorAll('#FacetFiltersFormMobile details.mobile-facets__details');
for (var i = 0; i < element.length; i++) {
	element[i].addEventListener('click', function(event) {
		if ( this.classList.contains("active") === true ){
          this.classList.remove("active");
        }else{
          this.classList.add("active");
        }
	});
}

// Marques slider
if (!!document.querySelector(".logos-marques.splide") === true){
  var splide = new Splide( '.logos-marques.splide', {
      type: 'loop',
      arrows: false,
      autoplay: true,
      autoWidth:true,
      interval: 5000,
      pauseOnHover: true,
      speed: 1200,
      perPage: 1,
      direction: 'ltr',
      focus: 'center',
      gap: '200px',
      pagination: false,
      easing: 'cubic-bezier(0.7, 0.01, 0.27, 0.99)',
      drag: false,
      breakpoints: {
            767: {
                drag: true,
                gap: '60px',
            },
	 },
  } );
  splide.mount();
}



// All labels défilent
/*if (!!document.querySelector(".silder-product") === true){
  var label_slide = document.querySelectorAll('.silder-product .splide .splide__list .splide__slide .all-labels');
  for (var i = 0; i < label_slide.length; i++) {
    var width_img = label_slide[i].parentElement.children[2].offsetWidth;
    var width_all_labels = label_slide[i].offsetWidth;
    if ( width_all_labels > width_img ){
      label_slide[i].style.cssText = "transform: translateX(-" + (width_all_labels - width_img) + "px);";
    }
  }
  var intervalID = window.setInterval(slide_labels, 5000);
  function slide_labels() {
    for (var i = 0; i < label_slide.length; i++) {
      var width_img = label_slide[i].parentElement.children[2].offsetWidth;
      var width_all_labels = label_slide[i].offsetWidth;
      if ( width_all_labels > width_img && label_slide[i].getAttribute("style") == "transform: translateX(0px);" ){
        label_slide[i].style.cssText = "transform: translateX(-" + (width_all_labels - width_img) + "px);";
      }else{
        label_slide[i].style.cssText = "transform: translateX(0px);";
      }
    }
  }
}*/

if (!!document.querySelector(".slideshow.splide") === true){
  var count_buble = document.querySelectorAll(".slideshow.splide .splide__pagination li").length;
  if ( count_buble == 1 ){
    document.querySelector(".slideshow.splide .splide__pagination li").style.cssText = "display: none;";
  }
}

document.addEventListener("DOMContentLoaded", function() {
  const urlParams = new URLSearchParams(window.location.search);
  const filterPromotions = urlParams.get('filter.promotions');

  if (filterPromotions) {
    document.querySelectorAll('.splide__slide').forEach(function(product) {
      const priceElement = product.querySelector('.real-price');
      const comparePriceElement = product.querySelector('.compare-at');

      if (priceElement && comparePriceElement) {
        const price = parseFloat(priceElement.textContent.replace(/[^0-9.-]+/g, ""));
        const comparePrice = parseFloat(comparePriceElement.textContent.replace(/[^0-9.-]+/g, ""));

        if (comparePrice <= price) {
          product.style.display = 'none'; // Hide non-promotional products
        }
      }
    });
  }
});





window.addEventListener('hashchange', function() {
    var nouvelleURL = window.location.hash.substring(1);
    console.log('Nouvelle URL : ', nouvelleURL);
});

// Appel initial pour afficher l'URL actuelle
var urlInitiale = window.location.hash.substring(1);
console.log('URL initiale : ', urlInitiale);



if (width_screen < 768) { 
  if (!!document.querySelector("#pourquoi-cette-montre") === true){
    document.querySelector("#pourquoi-cette-montre .title-mobile").onclick = function() {
      if ( document.querySelector("#pourquoi-cette-montre").classList.contains("active") === true ){
        document.querySelector("#pourquoi-cette-montre").classList.remove("active");
      }else{
        document.querySelector("#pourquoi-cette-montre").classList.add("active");
      }
    };
  }
  if (!!document.querySelector("#histoire-de-la-montre") === true){
    document.querySelector("#histoire-de-la-montre .title-mobile").onclick = function() {
      if ( document.querySelector("#histoire-de-la-montre").classList.contains("active") === true ){
        document.querySelector("#histoire-de-la-montre").classList.remove("active");
      }else{
        document.querySelector("#histoire-de-la-montre").classList.add("active");
      }
    };
  }
  if (!!document.querySelector("#description-technique") === true){
    document.querySelector("#description-technique .title-mobile").onclick = function() {
      if ( document.querySelector("#description-technique").classList.contains("active") === true ){
        document.querySelector("#description-technique").classList.remove("active");
      }else{
        document.querySelector("#description-technique").classList.add("active");
      }
    };
  }
}




// Joy Fidelity
window.addEventListener("load", (event) => {

  function checkJoyFidelity() {
    const btnJoyFidelity = document.querySelector("#Avada-Joy_FloatingButtonTrigger");
    if (btnJoyFidelity) {
      var btnPointsFidelity = document.querySelector(".points-fidelite span");
      if (!!btnPointsFidelity === true){
        btnPointsFidelity.onclick = function() {
          document.querySelector("#Avada-Joy_FloatingButtonTrigger").click();
        };
      }
    
      var urlPage = window.location.href;
      if (urlPage.includes("/account")){
        document.head.insertAdjacentHTML('beforeend', '<style class="styleCustomer">#Avada-Joy_FloatingButton{display: none;}</style>');
        
          document.querySelector("#Avada-Joy_FloatingButtonTrigger").click();
          setTimeout(function () {
            var nbPoints = document.querySelector(".Avada-Joy_CardMember .Avada-Joy-CardMember--Content p.Avada-Joy__PointNumber").textContent;
            if (nbPoints == "--points"){
              nbPoints = "0 point";
            }else{
              nbPoints = nbPoints.replace('points', ' points');
            }
            document.querySelector(".points-de-fidelite-block .nbPoints").textContent = nbPoints;
            document.querySelector(".points-de-fidelite-block").style.display = "block";
    
            document.querySelector(".points-de-fidelite-block .btn").addEventListener('click', (event) => {
              if (!!document.querySelector(".styleCustomer") === true){
                document.querySelector(".styleCustomer").remove();
              }else{
                document.querySelector("#Avada-Joy_FloatingButtonTrigger").click();
              }
            });
            
          }, 300);
      }else if (urlPage.includes("?fidelity=true")){
        document.querySelector("#Avada-Joy_FloatingButtonTrigger").click();
      }
      clearInterval(interval);
    }
  }
  
  const interval = setInterval(checkJoyFidelity, 250);
  setTimeout(() => clearInterval(interval), 5000);

});



if (!!document.querySelector(".product .payez-en-plusieurs-fois span.fois") === true){
  var fois = document.querySelectorAll('.product .payez-en-plusieurs-fois span.fois');
  for (var i = 0; i < fois.length; i++) {
    fois[i].addEventListener('click', function(event) {
      var currentTarget = event.currentTarget;
      if ( currentTarget.classList.contains("active") === false ){
        document.querySelector('.product .payez-en-plusieurs-fois span.fois.active').classList.remove("active");
        currentTarget.classList.add("active");
        document.querySelector(".product .payez-en-plusieurs-fois .fois-price").textContent = currentTarget.getAttribute("price");
        document.querySelector(".product .payez-en-plusieurs-fois span.nb-de-fois").textContent = currentTarget.textContent.replace(/\D/g,'') + "x";
      }
    });
  }
}




// Variables globales pour mémoriser les éléments
let elementsToMove = new Map();

function initElements() {
  const sections = document.querySelectorAll('.collage-liens');
  
  sections.forEach((section, index) => {
    const element1 = section.querySelector('.page-width .sous-part-1 a:first-child');
    const element2 = section.querySelector('.page-width .sous-part-2 a:nth-child(2)');
    
    if (element1 && element2) {
      elementsToMove.set(index, {
        element1: element1,
        element2: element2,
        originalParent1: element1.parentNode,
        originalParent2: element2.parentNode,
        nextSibling1: element1.nextSibling,
        nextSibling2: element2.nextSibling
      });
    }
  });
}

function handleResize() {
  const sections = document.querySelectorAll('.collage-liens');
  
  sections.forEach((section, index) => {
    const data = elementsToMove.get(index);
    if (!data) return;
    
    const { element1, element2, originalParent1, originalParent2, nextSibling1, nextSibling2 } = data;
    const part1 = section.querySelector('.page-width .part-1');
    const part2 = section.querySelector('.page-width .part-2');
    
    if (!part1 || !part2) return;
    
    if (window.innerWidth < 900) {
      part1.parentNode.insertBefore(element1, part1);
      part2.parentNode.insertBefore(element2, part2.nextSibling);
    } else {
      if (nextSibling1) {
        originalParent1.insertBefore(element1, nextSibling1);
      } else {
        originalParent1.appendChild(element1);
      }
      
      if (nextSibling2) {
        originalParent2.insertBefore(element2, nextSibling2);
      } else {
        originalParent2.appendChild(element2);
      }
    }
  });
}

initElements();
handleResize();
window.addEventListener('resize', handleResize);






// Header scroll hide/show functionality
(function() {
  let lastScrollTop = 0;
  let header = null;
  let announcementBar = null;
  let isInitialized = false;
  
  // Ajouter les styles CSS dynamiquement
  function addStyles() {
    const style = document.createElement('style');
    style.textContent = `
      #shopify-section-header.header-hidden {
        transform: translateY(-110px) !important;
      }
      #shopify-section-announcement-bar.announcement-hidden {
        transform: translateY(-100%) !important;
      }
    `;
    document.head.appendChild(style);
  }
  
  // Fonction pour initialiser les éléments
  function initElements() {
    header = document.querySelector('#shopify-section-header');
    announcementBar = document.querySelector('#shopify-section-announcement-bar');
    
    if (header || announcementBar) {
      isInitialized = true;
      
      // S'assurer que les éléments sont visibles au départ
      if (header) {
        header.classList.remove('header-hidden');
      }
      if (announcementBar) {
        announcementBar.classList.remove('announcement-hidden');
      }
    }
  }
  
  // Fonction de gestion du scroll
  function handleScroll() {
    // Initialiser si pas encore fait
    if (!isInitialized) {
      initElements();
      if (!isInitialized) return;
    }
    
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    // Scroll vers le bas - masquer
    if (scrollTop > lastScrollTop && scrollTop > 100) {
      if (header) {
        header.classList.add('header-hidden');
      }
      if (announcementBar) {
        announcementBar.classList.add('announcement-hidden');
      }
    }
    // Scroll vers le haut - afficher
    else if (scrollTop < lastScrollTop) {
      if (header) {
        header.classList.remove('header-hidden');
      }
      if (announcementBar) {
        announcementBar.classList.remove('announcement-hidden');
      }
    }
    
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }
  
  // Fonction d'initialisation complète
  function init() {
    addStyles(); // Ajouter les styles CSS
    initElements();
    
    // Event listener pour le scroll
    window.addEventListener('scroll', handleScroll);
    
    // Réessayer l'initialisation si les éléments ne sont pas encore présents
    if (!isInitialized) {
      setTimeout(init, 100);
    }
  }
  
  // Démarrer quand le DOM est prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Réinitialiser au chargement complet de la page
  window.addEventListener('load', function() {
    setTimeout(initElements, 100);
  });
  
})();